import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type { Store } from '@warp-drive/core';
import { query } from '@warp-drive/utilities/json-api';
import type { ItemStats } from '../schemas/item-stats.ts';

interface SearchMeta {
  total: number;
  page?: number;
  totalPages?: number;
}

interface SearchParams {
  q?: string;
  type?: string;
  page?: string;
}

export default class SearchRoute extends Route {
  @service declare store: Store;

  queryParams = {
    q: { refreshModel: true },
    type: { refreshModel: true },
    page: { refreshModel: true },
  };

  async model(params: Record<string, unknown>) {
    const { q, type, page } = params as SearchParams;
    if (!q) return { data: [], meta: { total: 0 } };

    const queryParams: Record<string, string> = {
      'page[number]': page ?? '1',
      'page[size]': '24',
      q,
      sort: '-createdAt',
    };
    if (type) queryParams['filter[type]'] = type;

    const { content } = await this.store.request(
      query('item-stat', queryParams, {
        resourcePath: 'items/stats',
      })
    );
    return content as unknown as { data: ItemStats[]; meta: SearchMeta };
  }
}
